import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { catchError } from "rxjs/operators";
import { ConfigService } from "../../shared/services/config.service";
import { UserService } from "../../shared/services/user.service";
import { ApiBaseService } from "./api-base.service";

@Injectable({
  providedIn: "root"
})
export class PrintersService extends ApiBaseService {
  constructor(private configService: ConfigService, private http: HttpClient, private us: UserService) {
    super(us);
    this.httpOptions = { headers: new HttpHeaders({ "content-type": "application/json", SessionId: this.userService.sessionId }) };
  }

  get baseUrl2() {
    return `${this.configService.config.directUrl}/api/printer`;
  }

  get(): Observable<any[]> {
    return this.http.get<any[]>(`${this.baseUrl2}/get`, this.httpOptions)
      .pipe(catchError(this.handleError<any[]>("Failed to get printers", [])));
  }

}
